<!--

Displays the following office information in a styled format:
- Days open
- hours open
- weekend (optional weekend hours ie. "Saturday 10-1")
- address
- pobox (optional)
- phone
- fax (optional)
- email
- courthouse (use this variable to autofill the courthouse address. Otherwise
  you'll have to enter the entire address in <slot></slot>)
- title (optional title if you don't want to use "Office Information")
- subtitle (optional subtitle under office information)

Sample usage:

<office-info
  hours-days="Monday thru Friday"
  hours="8:30AM to 4:30PM"
  floor="2nd Floor, Room 200"
  phone="(740) 283-8583"
  email="clerk@jeffersoncountyoh.com"
  courthouse="true"
  title="Optional Title"
  subtitle="Optional Subtitle"
></office-info>

-->

<template>
  <div>
    <text-box-title-two
    title-bg="primary"
    title-color="light"
    :title="titleCopy"
    :subtitle="subtitle">

      <div class="row">
        <div class="margin-top-1 col-md-5">

          <!-- begin hours area -->
          <div class="row pl-3">
            <div class="col-xs-1 icon-width">
              <i class="material-icons">schedule</i>
            </div>

            <div class="col-xs-11">
              <span class="text-underline">Office Hours</span>
              <div>
                {{hoursDays}}
              </div>
              <div>
                {{hours}}
              </div>

              <div v-if="weekend" class="weekend">
                {{weekend}}
              </div>

              <div v-if="caveat" class="caveat">
                {{caveat}}
              </div>
            </div>
          </div>
          <!-- end hours area -->

        </div>

        <div class="address col-md-7">
          <div v-if="courthouse" class="pl-3">
            <address-simple
            line1="Jefferson County Courthouse"
            line2="301 Market Street"
            :line3="pobox"
            line4="Steubenville, OH 43952"
            :line5="floor"
            >
            </address-simple>
          </div>

          <div v-else class="pl-3">
            <slot></slot>  
          </div>
        </div>
        
      </div>

      <div>
        <div class="row justify-start phone-email">
          <div class="phone col-md-5">
            <div>
              <i class="material-icons">call</i>
              {{phone}}
            </div>

            <div v-if="fax">
              <i class="material-icons">print</i>
              {{fax}}
            </div>
          </div>

          <div class="email col-md-7">
            <i class="material-icons">email</i>&nbsp;
            <a :href="`mailto:${this.email}`" class="text-blue-grey-7 link-hover">{{email}}</a>
          </div>
        </div>
      </div>

    </text-box-title-two>
  </div>
</template>

<script>
import TextBoxTitleTwo from '../layout/TextBoxTitleTwo'
import AddressSimple from '../display-utils/AddressSimple'

export default {
  components: {
    TextBoxTitleTwo,
    AddressSimple
  },
  data () {
    return {
      titleCopy: "Office Information"
    }
  },
  props: ["hours","hoursDays","weekend","pobox","floor","phone","fax","email","courthouse","title","subtitle","caveat"],
  created: function() {
    this.changeTitle()
  },
  methods: {
    changeTitle: function() {
      if (this.title != null && this.title != "") {
        this.titleCopy = this.title
      }
    }
  }
}
</script>

<style scoped>
.weekend {
  margin-top: 1.0em;
}

.caveat {
  margin-top: 1.0em;
  font-style: italic;
  font-size: 0.9rem;
}

.address {
  margin-top: 1.0em;
}

.phone-email {
  margin-top: 1.0em;
}

.phone {
  display: inline;
  padding-right: 1.0em;
}

.email {
  display: inline;
}

.email a {
  font-weight: bold;
}

.icon-width {
  max-width: 16px;
  margin-right: 10px;
}

</style>
